import {
  Box,
  TableContainer,
  TableCell as TableCellStyles,
  Table as TableStyles,
  styled,
  Typography,
  DialogContent,
} from '@mui/material';

export const Content = styled(Box)`
  .header-guests {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #bdbdbd;

    h3 {
      margin-left: 30%;
    }
  }

  .btn-save-guest {
    padding: 6px 10px;
    height: 36px;
    border-radius: 4px;
    width: 154px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 14px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #ffffff;
  }
  .btn-delete-guest {
    padding: 6px 10px;
    height: 36px;
    border-radius: 4px;
    width: 154px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 14px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #ffffff;
  }

  form {
    width: 100%;
    display: grid;
    grid-template-areas: 'l l' 'f f';
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 4fr 1fr;

    height: 100vh;
    .title {
      font-weight: 400;
      font-size: 24px;
      color: #303030;
      margin-bottom: 20px;
    }

    .label {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 28px;
      display: flex;
      align-items: center;
      letter-spacing: 0.15px;
      color: #212121;
      margin-bottom: 10px;

      gap: 10px;
    }
  }
  .add-logo {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 10px;
    gap: 10px;
    width: 440px;
    height: 60px;
    border: 1px dashed #bdbdbd;
    border-radius: 6px;
    width: 100%;
    margin-bottom: 20px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.15px;
    color: #212121;
    cursor: pointer;
  }

  .gridContainer {
    grid-area: l;
  }

  .gridButtons {
    grid-area: f;
  }
`;

export const Container = styled(Box)`
  height: 100%;
`;

export const Text = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`;

export const TextButton = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #206da7;
`;

export const Card = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 15px;
  height: 78px;
  border: 1px solid #dddddd;
  border-radius: 6px;
  align-items: center;
  cursor: pointer;
  .name {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
    margin: 0;
  }
  .duration {
    margin: 0;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }

  .description {
    margin: 0;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.15px;
    color: #000000;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .btn-archive {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 16px 6px 12px;
    gap: 8px;

    width: 117px;
    height: 40px;
  }
`;

export const Div = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 15px;
  // p {
  //   color: black;
  //   font-style: normal;
  //   font-weight: 500;
  //   font-size: 18px;
  //   line-height: 22px;
  // }

  .input-date {
    background-color: #4c4c4c;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 2px solid #fdfdfd;
    width: 180px;
    height: 24px;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #fdfdfd;
  }

  .select-date {
    color: #fdfdfd;
    width: 220px;
  }
  .icon {
    color: #fdfdfd;
  }

  .title {
    height: 40px;
    padding: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .title-modal {
    font-size: 18px;
    margin: 0;
  }

  .align-input {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 10px;
  }

  .align {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 35px;
    margin-left: 5px;
  }

  .css-3mvg2v-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {
    border-bottom: 2px solid rgb(255 255 255);
  }

  .css-jj8kbs-MuiSvgIcon-root-MuiSelect-icon {
    color: rgba(255 255 255);
  }

  .btn-add-data {
    width: auto;
    height: 42px;
    display: flex;
    align-items: center;
    gap: 5px;
  }
`;

export const Section = styled(Box)`
  margin: 20px 20px 20px 20px;
  border: 1px solid #12094d;
  padding: 20px;
  border-radius: 6px;

  &.disabled {
    background-color: ${({ theme }) => theme.palette.grey[400]};
    cursor: not-allowed;

    button {
      border-radius: 32px;
      height: 24px;
      color: ${({ theme }) => theme.palette.common.white};
      text-transform: capitalize;
      background-color: ${({ theme }) => theme.palette.grey.A100};
    }
  }

  .content {
    padding: 15px 20px;
    width: 100%;

    ul {
      padding: 0;
    }

    li {
      list-style: none;
    }
  }

  .content-guests {
    padding: 5px 20px 0px 20px;
  }

  .meeting-details {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    margin-bottom: 20px;
  }

  .buttons {
    display: flex;
    gap: 20px;
  }

  .btn-cancel {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 32px;
    width: 64px;
    height: 24px;
    text-transform: capitalize;
  }

  .btn-save {
    background: #4caf50;
    border-radius: 32px;
    width: 151px;
    height: 24px;
    color: ${({ theme }) => theme.palette.common.white};
    text-transform: capitalize;
  }

  h4 {
    margin: 5px 0 5px 0;
    padding: 0;
  }

  .input-date {
    display: flex;
    flex-direction: row;
    gap: 0px;
    width: 78%;
  }

  .inputs {
    width: 100%;
  }

  .initial-input {
    width: 90%;
    ::-webkit-datetime-local-edit-year-field:not([aria-valuenow]),
    ::-webkit-datetime-local-edit-month-field:not([aria-valuenow]),
    ::-webkit-datetime-local-edit-day-field:not([aria-valuenow]) {
      color: transparent;
    }
  }

  .btn-repetition {
    /* width: 134px; */
    height: 44px;
    margin-bottom: 10px;
  }

  .date {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .checkbox {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    gap: 11px;
  }

  .link {
    margin-top: 10px;
  }

  .section-conference {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .menu-left {
    display: flex;
    flex-direction: column;
  }

  .btn-conference {
    height: 24px;
    border-radius: 32px;
    text-transform: capitalize;
  }

  .section-guests {
    display: flex;
    flex-direction: column;
  }

  .box-items {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .title-conference {
    margin: 0;
  }

  .btn-edit {
    background-color: #206da7;
    color: ${({ theme }) => theme.palette.common.white};
    text-transform: capitalize;
  }

  .btn-rounded {
    border-radius: 32px;
    height: 24px;
  }
  .datetime-input {
    width: 100%;
  }
`;

export const TableContainerStyles = styled(TableContainer)`
  margin-top: 18px;
  background: #ffffff;
  box-shadow: 0px 3px 5px -2px rgba(0, 0, 0, 0.2),
    0px 2px 3px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  .css-1moeq7m-MuiTableHead-root {
    background-color: #fff;
  }
  .css-1moeq7m-MuiTableHead-root
    .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root {
    color: black;
  }
  .css-1moeq7m-MuiTableHead-root
    .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active {
    color: black;
  }
`;

export const TableCell = styled(TableCellStyles)`
  font-size: 14px;
`;

export const Table = styled(TableStyles)`
  .css-1xkvp8t-MuiSvgIcon-root {
    width: 0;
  }

  .css-hw22yz-MuiTableCell-root {
    font-size: 16px;
  }
`;

export const FileListContainer = styled(Box)``;

export const FileItem = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #eeeeee;
  padding: 8px 10px;
  gap: 10px;
  border-radius: 6px;

  & + div {
    margin-top: 20px;
  }
`;

export const FileInfo = styled(Box)`
  display: flex;
  align-items: center;
`;

export const FileIcon = styled(Box)`
  height: 24px;
  width: 24px;
`;

export const FileName = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.grey[800]};
  margin-left: 10px;
`;

export const FileActions = styled(Box)`
  svg {
    color: #323232;
  }
`;

export const DialogContentStyles = styled(DialogContent)`
  @media print {
    display: none;
  }
`;
